export type EquityMarketContractTemplateVariable = {
  token: string;
  labelKey: string;
};

export const EQUITY_MARKET_CONTRACT_TEMPLATE_VARIABLES: EquityMarketContractTemplateVariable[] =
  [
    { token: '{MERCADO_NOMBRE_COMPRADOR}', labelKey: 'EquityMarketContractVarBuyerName' },
    { token: '{MERCADO_NOMBRE_VENDEDOR}', labelKey: 'EquityMarketContractVarSellerName' },
    { token: '{MERCADO_DNI_COMPRADOR}', labelKey: 'EquityMarketContractVarBuyerId' },
    { token: '{MERCADO_DNI_VENDEDOR}', labelKey: 'EquityMarketContractVarSellerId' },
    { token: '{MERCADO_NUM_ACCIONES}', labelKey: 'EquityMarketContractVarShareCount' },
    { token: '{MERCADO_CLASE_ACCIONES}', labelKey: 'EquityMarketContractVarShareClass' },
    { token: '{MERCADO_PRECIO_ACCION}', labelKey: 'EquityMarketContractVarPricePerShare' },
    { token: '{MERCADO_PRECIO_TOTAL}', labelKey: 'EquityMarketContractVarTotalPrice' },
    { token: '{MERCADO_FECHA}', labelKey: 'EquityMarketContractVarDate' },
    { token: '{MERCADO_HORA}', labelKey: 'EquityMarketContractVarTime' },
    {
      token: '{MERCADO_REFERENCIA_OPERACION}',
      labelKey: 'EquityMarketContractVarOperationRef',
    },
    { token: '{SOCIEDAD_NOMBRE}', labelKey: 'EquityMarketContractVarSocietyName' },
    { token: '{SOCIEDAD_CIF}', labelKey: 'EquityMarketContractVarSocietyTaxId' },
    { token: '{SOCIEDAD_CIUDAD}', labelKey: 'EquityMarketContractVarCity' },
  ];
